import { callGetApi, callPostApi, callPutApi } from "./api";

// Stripe connected-account status; wallet flags turn on only once charges_enabled is true.
export function getPaymentAccount(storeId) {
  return callGetApi({ url: `admin/stores/${storeId}/payment-account` });
}

// Single-use Stripe onboarding URL that expires in minutes: open it at once, never email or log it.
export function createPaymentAccountLink(storeId) {
  return callPostApi({ url: `admin/stores/${storeId}/payment-account/link` });
}

// The API refuses an off -> on change until the store's account can take charges.
export function updatePaymentWallets(storeId, flags) {
  return callPutApi({ url: `admin/stores/${storeId}/payment-account/wallets`, body: flags });
}
